import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getProduct } from '../utils/api';
import SizeSelector from '../components/SizeSelector';
import QuantityInput from '../components/QuantityInput';
import { useState } from 'react';
import { useCart } from '../context/CartContext';

export default function Product(){
  const { slug } = useParams();
  const { data:product } = useQuery({ queryKey:['product', slug], queryFn:()=>getProduct(slug) });
  const [size,setSize]=useState(product?.sizes?.[0]?.title||null);
  const [qty,setQty]=useState(1);
  const { add } = useCart();
  if (!product) return <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">Loading…</main>;
  const hasOffer = product.offerPrice && product.offerPrice < product.price;
  return (<main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
    <div className="grid gap-8 md:grid-cols-2">
      <div className="aspect-square rounded-2xl bg-slate-100 overflow-hidden">
        <img src={product.image} alt={product.name} className="h-full w-full object-cover"/>
      </div>
      <div>
        <h1 className="text-2xl font-bold">{product.name}</h1>
        <div className="mt-2 text-slate-600" dangerouslySetInnerHTML={{__html:product.short||''}} />
        <div className="mt-3 flex items-center gap-2">
          {hasOffer ? <><div className="text-2xl font-bold">KSh {Number(product.offerPrice).toLocaleString()}</div><div className="text-sm text-slate-500 line-through">KSh {Number(product.price).toLocaleString()}</div></> : <div className="text-2xl font-bold">KSh {Number(product.price).toLocaleString()}</div>}
        </div>
        {product.sizes?.length ? (<div className="mt-4"><div className="text-sm font-semibold mb-2">Select size</div><SizeSelector sizes={product.sizes} value={size} onChange={setSize}/></div>) : null}
        <div className="mt-4"><QuantityInput value={qty} onChange={setQty}/></div>
        <button onClick={()=>add({...product}, qty, size)} className="mt-6 rounded-xl bg-slate-900 px-5 py-3 text-white">Add to Cart</button>
        <div className="mt-6 prose max-w-none" dangerouslySetInnerHTML={{__html:product.description||''}} />
      </div>
    </div>
  </main>);
}
